export const OPEN_NAVIGATION = 'NAVIGATION/OPEN_NAVIGATION';
export const CLOSE_NAVIGATION = 'NAVIGATION/CLOSE_NAVIGATION';

export function openNavigation() {
    return { type: OPEN_NAVIGATION };
}

export function closeNavigation() {
    return { type: CLOSE_NAVIGATION };
}
